export default __webpack_public_path__ + "static/media/Vedlegg 3 - Prosjektsøknad.42867367.pdf";